import { useState } from 'react';
import Main from '../../../component/Main.jsx';
import SearchBtn from '../../../component/common/button/SearchBtn.jsx';
import NewDataGrid from '../../../component/common/dataGrid/NewDataGrid.jsx';
import NewCommonSelect from '../../../component/common/selectBox/NewCommonSelect.jsx';

const BdTrmsMiwan = () => {

    const [searchParams, setSearchParams] = useState({
        searchFromdate: new Date((new Date()).getTime() + 1000 * 60 * 60 * 9).toISOString().split('T')[0],
        searchTodate: new Date((new Date()).getTime() + 1000 * 60 * 60 * 9).toISOString().split('T')[0],
        searchEmog: '',
        searchDateCls: 'indt',
        searchIdno: '',
        searchGrdc: '',
        searchLoca: '',
        searchGubun: '*',
        validationCheckList: ['searchEmog']
    });

    const searchParamsAdditional = {};

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        const newParams = {
            ...searchParams,
            [name]: value
        };
        setSearchParams(newParams);
    };

    const dataHead = ['NO.', '기관명', '등록번호', '내원일자', '내원시간', '전송일시', '구분']; //component화 
    const dataColumn = ['SEQ', 'EMOGDESC', 'TRMSMASK', 'TRMSINDT', 'TRMSINTM', 'WDKTWDTM', 'TRMSSTAT'];
    const apiCall = '/ptmiapi/gumto/bdtrmsmiwan_search.do';
    const apiCntCall = '/ptmiapi/gumto/bdtrmsmiwan_cnt.do';
    const excelFileName = '미완료 데이터';
    const excelHead = [];

    const propsInfo = {
        dataHead: dataHead,
        dataColumn: dataColumn,
        apiCall: apiCall,
        apiCntCall: apiCntCall,
        excelFileName: excelFileName,
        excelHead: excelHead
    }

    const [state, setState] = useState({
        dataList: [],
        isSearched: false,
        isLoading: false
    })

    const [pageInfo, setPageInfo] = useState({
        paginationTF: true,
        currentPage: 1,
        itemsPerPage: 50, // 한 페이지당 보여줄 데이터 수
        totalItems: 0 // 전체 데이터 수
    });

    return (
        <Main>
            <div className="com-search">
                <table>
                    <colgroup>
                        <col width="10%" />
                        <col width="25%" />
                        <col width="7%" />
                        <col width="20%" />
                        <col width="10%" />
                        <col width="18%" />
                    </colgroup>
                    <tbody>
                        <tr>
                            <NewCommonSelect
                                hospitalTF={true}
                                searchParams={searchParams}
                                handleInputChange={handleInputChange}
                            />
                        </tr>
                        <tr>
                            <th>
                                <select
                                    id="searchDateCls"
                                    name="searchDateCls"
                                    value={searchParams.searchDateCls}
                                    onChange={handleInputChange}
                                >
                                    <option value="indt">내원일시</option>
                                    <option value="wkdt">전송일시</option>
                                </select>
                            </th>
                            <td>
                                <input
                                    type="date"
                                    name="searchFromdate"
                                    value={searchParams.searchFromdate}
                                    onChange={handleInputChange}
                                />
                                &nbsp;~&nbsp;
                                <input
                                    type="date"
                                    name="searchTodate"
                                    value={searchParams.searchTodate}
                                    onChange={handleInputChange}
                                    min={searchParams.searchFromdate}
                                />
                            </td>
                            <th>구분</th>
                            <td>
                                <div className='flex gap-3'>
                                    <label>
                                        <input
                                            type="radio"
                                            name="searchGubun"
                                            value="*"
                                            checked={searchParams.searchGubun === '*'}
                                            onChange={handleInputChange}
                                        />
                                        전체
                                    </label>
                                    <label>
                                        <input
                                            type="radio"
                                            name="searchGubun"
                                            value="C"
                                            checked={searchParams.searchGubun === 'C'}
                                            onChange={handleInputChange}
                                        />
                                        입력중
                                    </label>
                                    <label>
                                        <input
                                            type="radio"
                                            name="searchGubun"
                                            value="F"
                                            checked={searchParams.searchGubun === 'F'}
                                            onChange={handleInputChange}
                                        />
                                        입력완료
                                    </label>
                                </div>
                            </td>
                            <th>등록번호</th>
                            <td>
                                <input
                                    type="text"
                                    id="searchIdno"
                                    name="searchIdno"
                                    value={searchParams.searchIdno}
                                    onChange={handleInputChange}
                                />
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <SearchBtn
                propsInfo={propsInfo}
                state={state}
                setState={setState}
                searchParams={searchParams}
                searchParamsAdditional={searchParamsAdditional}
                pageInfo={pageInfo}
                setPageInfo={setPageInfo}
            />
            <NewDataGrid
                propsInfo={propsInfo}
                state={state}
                pageInfo={pageInfo}
                setPageInfo={setPageInfo}
            />
        </Main>
    )
}

export default BdTrmsMiwan;